<template>
  <div class="filters-group ds">
    <div class="">
      <div class="d-flex align-items-center w-100 search-row">
        <div class="search-bar-wrapper">
          <search-bar :config="config" :showSaveSearch="showSaveSearch" />
        </div>
        <div v-if="showSaveSearch" class="search-save-wrapper">
          <search-save />
        </div>
      </div>
      <div class="ec-search-result">
        <div class="row margin-0-mobile">
          <search-count :config="config" />
          <search-api-link :config="config" />
          <div class="ml-auto d-md-block">
            <search-sort-dropdown
              v-show="getSortType !== 'mostLiked'"
              :config="config"
            />
          </div>
        </div>
        <hr class="d-none d-md-block small-line" />
        <!-- ADVANCED SEARCH SPECIAL FILTERS (to be moved to a separate component) -->
        <!-- Search in -->
        <div class="advanced-search-filters">
          <span v-if="activeFilters.title" class="search-in">
            {{ $t("message.header.subnav.search") }} in
            {{ $t("message.metadata.title") }}
            <span class="close-facet ml-2" @click="removeFilter('title')"
              >×</span
            >
          </span>
          <span v-if="activeFilters.description" class="search-in">
            {{ $t("message.header.subnav.search") }} in
            {{ $t("message.metadata.description") }}
            <span class="close-facet ml-2" @click="removeFilter('description')"
              >×</span
            >
          </span>
          <span v-if="activeFilters.keywords" class="search-in">
            {{ $t("message.header.subnav.search") }} in
            {{ $t("message.datasetFacets.facets.keywords") }}
            <span class="close-facet ml-2" @click="removeFilter('keywords')"
              >×</span
            >
          </span>
          <span v-if="activeFilters.categories" class="search-in">
            {{ $t("message.header.subnav.search") }} in
            {{ $t("message.metadata.categories") }}
            <span class="close-facet ml-2" @click="removeFilter('categories')"
              >×</span
            >
          </span>
          <span v-if="activeFilters.dateRange" class="search-in">
            {{ getDateTypeLabel }}: {{ formatDateRange }}
            <span class="close-facet ml-2" @click="removeFilter('dateRange')"
              >×</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/search/search-filters/SearchBar";
import SearchCount from "@/components/search/search-filters/SearchCount";
import SearchApiLink from "@/components/search/search-filters/SearchApiLink";
import SearchSortDropdown from "@/components/search/search-filters/SearchSortDropdown";
import SearchSave from "@/components/search/search-filters/SearchSave";

export default {
  name: "SearchFilters",
  data() {
    return {
      searchInTitle: false,
      searchInDesc: false,
      activeFilters: {
        title: false,
        description: false,
        keywords: false,
        categories: false,
        dateRange: false,
      },
      dateRange: {
        min: null,
        max: null,
      },
    };
  },
  components: {
    SearchSortDropdown,
    SearchApiLink,
    SearchCount,
    SearchBar,
    SearchSave,
  },
  props: {
    config: Object,
    showSaveSearch: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  computed: {
    getSortType() {
      return this.$store.getters["search/getSortType"];
    },
    getFacets() {
      return this.$store.getters[
        `${this.config.getFacets[0]}/${this.config.getFacets[1]}`
      ];
    },
    getDateTypeLabel() {
      const dateType = this.$route.query.dateType;

      switch (dateType) {
        case "issued":
          return "Issued Date";
        case "temporal":
          return "Temporal Date";
        case "modified":
        default:
          return "Modified Date";
      }
    },
    formatDateRange() {
      if (!this.dateRange.min && !this.dateRange.max) return "";

      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toLocaleDateString();
      };

      if (this.dateRange.min && this.dateRange.max) {
        return `${formatDate(this.dateRange.min)} - ${formatDate(this.dateRange.max)}`;
      } else if (this.dateRange.min) {
        return `From ${formatDate(this.dateRange.min)}`;
      } else {
        return `Until ${formatDate(this.dateRange.max)}`;
      }
    },
  },
  methods: {
    clearQuery() {
      this.query = "";
      this.searchInDesc = false;
      this.searchInTitle = false;
      sessionStorage.setItem("titleQuery", "");
      sessionStorage.setItem("descQuery", "");
      sessionStorage.setItem("query", "");

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      params.delete("query");
      params.delete("filter");
      if (params.has("fields") && params.get("fields").startsWith("title.")) {
        params.delete("fields");
      } else if (
        params.has("fields") &&
        params.get("fields").startsWith("description.")
      ) {
        params.delete("fields");
      }

      window.history.replaceState(
        {},
        "",
        `${url.pathname}?${params.toString()}`,
      );

      // Trigger reload of "Advanced Search count"
      // Hacky solution since nothing else worked yet:
      window.location.reload();
    },
    removeFilter(filterType) {
      const query = { ...this.$route.query };

      switch (filterType) {
        case "dateRange":
          delete query.minDate;
          delete query.maxDate;
          break;
        case "title":
        case "description":
        case "keywords":
        case "categories":
          if (query.fields) {
            // Entferne nur das spezifische Feld aus fields
            query.fields = query.fields
              .split(",")
              .filter((f) => !f.startsWith(`${filterType}.`))
              .join(",");
            // Falls keine Felder mehr übrig sind, entferne fields komplett
            if (!query.fields) {
              delete query.fields;
            }
          }
          // Entferne ggf. den spezifischen Query-Parameter
          delete query[`${filterType}Query`];
          break;
      }

      this.$router.replace({ query });
    },
    updateFields(params, prefix) {
      if (params.has("fields")) {
        const fields = params.get("fields").split(",");
        const updatedFields = fields.filter((f) => !f.startsWith(prefix));

        if (updatedFields.length) {
          params.set("fields", updatedFields.join(","));
        } else {
          params.delete("fields");
        }
      }
    },

    checkUrlParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const fields = urlParams.get("fields")?.split(",") || [];

      // Error check
      this.activeFilters.title = fields.some((f) => f.startsWith("title."));
      this.activeFilters.description = fields.some((f) =>
        f.startsWith("description."),
      );
      this.activeFilters.keywords = fields.some((f) =>
        f.startsWith("keywords."),
      );
      this.activeFilters.categories = fields.some((f) =>
        f.startsWith("categories."),
      );

      // Check Date Range
      if (urlParams.has("minDate") || urlParams.has("maxDate")) {
        this.activeFilters.dateRange = true;
        this.dateRange.min = urlParams.get("minDate");
        this.dateRange.max = urlParams.get("maxDate");
      }
    },
  },
  created() {
    this.checkUrlParameters();
  },
};
</script>

<style lang="scss" scoped>
.small-line {
  border-top: 1px solid #dee2e6;
}
.advanced-search-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px;
}

.search-in {
  background-color: #515560;
  color: #fff;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  svg {
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.2);
    }
  }
}

.close-facet {
  cursor: pointer;
}

/* Align SearchSave with the search bar */
.filters-group .d-flex {
  align-items: center;
  gap: 8px;
}

/* Make the bookmark button match the height of the search field */
.filters-group :deep(.search-save) {
  display: flex;
  align-items: center;
}

.filters-group :deep(.bookmark-btn) {
  width: 48px;
  height: 48px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Flex wrappers: search bar grows, save stays fixed */
.search-row {
  gap: 8px;
}
.search-bar-wrapper {
  flex: 1 1 auto;
  min-width: 0; /* allow child to shrink */
}
.search-save-wrapper {
  flex: 0 0 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 767.5px) {
  .margin-0-mobile {
    margin: 0;
  }
  /* hide the desktop-positioned save button on mobile (we render it inside SearchBar) */
  .search-save-wrapper {
    display: none;
  }
}
</style>
